(function () {
  var KEY = 'gg-shortlist';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* private mode: heart still works for the session via memory fallback */
      memoryList = list;
    }
    updateBadges();
  }

  var memoryList = null;

  function all() {
    return memoryList || read();
  }

  function has(handle) {
    return all().some(function (i) { return i.handle === handle; });
  }

  function add(item) {
    var list = all();
    if (!list.some(function (i) { return i.handle === item.handle; })) {
      list.push(item);
      write(list);
    }
  }

  function remove(handle) {
    write(all().filter(function (i) { return i.handle !== handle; }));
  }

  window.GGShortlist = { all: all, has: has, add: add, remove: remove };

  function updateBadges() {
    var n = all().length;
    document.querySelectorAll('[data-shortlist-count]').forEach(function (el) {
      el.textContent = n < 100 ? n : '99';
      var bubble = el.closest('.shortlist-count-bubble');
      if (bubble) bubble.hidden = n === 0;
    });
    document.querySelectorAll('.header__icon--shortlist').forEach(function (a) {
      a.classList.toggle('has-items', n > 0);
    });
    // once there is something saved, the header is a way back to the list,
    // not an invitation to start one
    document.querySelectorAll('.header__icon--shortlist .shortlist-label').forEach(function (el) {
      el.innerHTML = n > 0
        ? 'My Wishlist (' + (n < 100 ? n : '99+') + ')'
        : '<span class="shortlist-new">New!</span>Add to Wishlist';
    });
  }

  /* ---- usage counting -------------------------------------------------
     Every heart click fires a Klaviyo custom event so we can count real
     saves instead of guessing from wishlist page views. Anonymous shoppers
     get a durable local id; if Klaviyo already knows the email the event
     lands on the real profile instead. Counting must never break the heart,
     so everything here is wrapped and failure is silent. -------------- */
  var KL_COMPANY = window.GG_KLAVIYO_KEY || 'TNx3gg';
  var VID_KEY = 'gg-visitor-id';
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function visitorId() {
    try {
      var v = localStorage.getItem(VID_KEY);
      if (!v) {
        v = 'ggv-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
        localStorage.setItem(VID_KEY, v);
      }
      return v;
    } catch (e) {
      return 'ggv-private-mode';
    }
  }

  function knownEmail() {
    try {
      var m = document.cookie.match(/__kla_id=([^;]+)/);
      if (!m) return null;
      var data = JSON.parse(atob(decodeURIComponent(m[1])));
      var email = data && (data.$email || data.email);
      return EMAIL_RE.test(email || '') ? email : null;
    } catch (e) {
      return null;
    }
  }

  function track(metric, props) {
    try {
      var who = { $anonymous: visitorId() };
      var email = knownEmail();
      if (email) who.$email = email;
      var data = btoa(unescape(encodeURIComponent(JSON.stringify({
        token: KL_COMPANY,
        event: metric,
        customer_properties: who,
        properties: props || {}
      }))));
      /* Plain GET on purpose. Klaviyo's newer /client/events endpoint needs a
         custom header, which makes the browser send a CORS preflight that
         Klaviyo answers with OPTIONS-only, so the save never gets reported.
         This endpoint needs no custom headers, so there is no preflight. */
      fetch('https://a.klaviyo.com/api/track?data=' + encodeURIComponent(data), {
        method: 'GET',
        keepalive: true
      }).catch(function () {});
    } catch (e) {
      /* never let counting break the button */
    }
  }

  window.GGShortlistTrack = track;

  var toastEl = null;
  var toastTimer = null;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'shortlist-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('show');
    }, 3500);
  }

  var HEART_OUTLINE =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 20.5c-4.6-3.6-8.5-6.7-8.5-10.4C3.5 7.2 5.7 5 8.4 5c1.5 0 2.8.7 3.6 1.8C12.8 5.7 14.1 5 15.6 5c2.7 0 4.9 2.2 4.9 5.1 0 3.7-3.9 6.8-8.5 10.4z"/></svg>';
  var HEART_FILLED =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 20.5c-4.6-3.6-8.5-6.7-8.5-10.4C3.5 7.2 5.7 5 8.4 5c1.5 0 2.8.7 3.6 1.8C12.8 5.7 14.1 5 15.6 5c2.7 0 4.9 2.2 4.9 5.1 0 3.7-3.9 6.8-8.5 10.4z"/></svg>';

  function paintToggle(btn) {
    var saved = has(btn.dataset.handle);
    btn.classList.toggle('is-saved', saved);
    var icon = btn.querySelector('[data-heart]');
    var label = btn.querySelector('[data-label]');
    if (icon) icon.innerHTML = saved ? HEART_FILLED : HEART_OUTLINE;
    if (label) label.textContent = saved ? btn.dataset.labelSaved : btn.dataset.labelSave;
  }

  function shortlistUrl() {
    return window.GG_SHORTLIST_URL || '/collections/all?view=wishlist';
  }

  function wireToggles(root) {
    (root || document).querySelectorAll('[data-shortlist-toggle]').forEach(function (btn) {
      if (btn.dataset.wired) return;
      btn.dataset.wired = '1';
      paintToggle(btn);
      btn.addEventListener('click', function () {
        if (has(btn.dataset.handle)) {
          remove(btn.dataset.handle);
          track('Removed from Wishlist', {
            handle: btn.dataset.handle,
            title: btn.dataset.title,
            list_size: all().length
          });
          toast('Removed from your wishlist.');
        } else {
          add({
            handle: btn.dataset.handle,
            title: btn.dataset.title,
            url: btn.dataset.url,
            image: btn.dataset.image,
            price: btn.dataset.price
          });
          track('Added to Wishlist', {
            handle: btn.dataset.handle,
            title: btn.dataset.title,
            price: btn.dataset.price,
            url: btn.dataset.url,
            list_size: all().length,
            saved_from: location.pathname
          });
          toast(
            'Saved. It’ll be here when you come back. <a href="' +
              shortlistUrl() +
              '">View your wishlist</a>'
          );
        }
        paintToggle(btn);
      });
    });
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    var ta = document.createElement('textarea');
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    return Promise.resolve();
  }

  function wireShareButtons(root) {
    (root || document).querySelectorAll('[data-share-product]').forEach(function (btn) {
      if (btn.dataset.wired) return;
      btn.dataset.wired = '1';
      btn.addEventListener('click', function () {
        var url = btn.dataset.url + '?utm_source=share&utm_medium=link&utm_campaign=shortlist';
        var title = btn.dataset.title || document.title;
        track('Shared a Shirt', { handle: btn.dataset.handle, title: title });
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else {
          copyText(url).then(function () {
            toast('Link copied. Send it to whoever needs to see this shirt.');
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateBadges();
    wireToggles();
    wireShareButtons();
  });

  window.GGShortlistUI = { toast: toast, copyText: copyText, wireToggles: wireToggles, updateBadges: updateBadges };
})();
